import { ReactNode } from 'react';
import { Layout as AntdLayout } from 'antd';
import Sidebar from '../Sidebar/Sidebar';
import useGlobalContext from 'app/providers/GlobalProvider';
const { Content } = AntdLayout;

const Layout = ({ children }: { children: ReactNode }) => {
  const { globalState } = useGlobalContext();
  if (globalState?.isRenouvellement) {
    return (
      <AntdLayout className='layout'>
        <Content>{children}</Content>
      </AntdLayout>
    );
  }
  return (
    <AntdLayout className='layout'>
      <Sidebar />
      <Content className={`main-content ${globalState?.isDevisPath ? 'main-content-devis' : ''}`}>{children}</Content>
    </AntdLayout>
  );
};

export default Layout;
